import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom'
import InvoiceIcon from '../../Images/MoversLogo.png';
import move from '../../Images/move.png';
import network from '../../Images/network.png';
import pack from '../../Images/pack.png';
import store from '../../Images/store.png';
import technology from '../../Images/partners.png';
import track from '../../Images/track.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faLongArrowAltRight
} from '@fortawesome/free-solid-svg-icons';
import Alert from 'react-s-alert';
import '../Login/LoginStyle.css';
import baseURL from '../Common/Config';
import { AuthDataContext } from '../Common/AuthenticateUser';
import Axiosfetch from '../Common/Axiosfetch';
import FailureAlert from '../Common/Failure';
import WelcomeIcon from '../../Images/MFILogo.png';
import * as yup from 'yup';
import { CallBackAlert } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const UserDetails =
{
    UserName: '',
    Password: '',
    Authenticate: false,
    AuthMessage: ''
};

const User = {
    UserName: "",
    FirstName: "",
    LastName: "",
    EmailID: "",
    RoleID: 0,
    OrganizationID: 0,
    PhoneNumber: "",
    Password: "",
    IsNewUser: 0,
    UserType: 1,
    Status: 0,
    IsDeleted: 0
};

const UserSchema = yup.object().shape({
    EmailID: yup.string().trim().required().email(),
    LastName: yup.string().trim().required(),
    FirstName: yup.string().trim().required(),
    UserName: yup.string().trim().required(),
    PhoneNumber: yup.number().typeError('Enter Valid Phone Number').required().min(10, 'Phone Number should be 10 digit'),
    Password: yup.string().trim().required().min(6),
});

document.addEventListener("keyup", function (e) {
    var keyCode = e.keyCode ? e.keyCode : e.which;
    if (keyCode === 44) {
        var inpFld = document.createElement("input");
        inpFld.setAttribute("value", ".");
        inpFld.setAttribute("width", "0");
        inpFld.style.height = "0px";
        inpFld.style.width = "0px";
        inpFld.style.border = "0px";
        document.body.appendChild(inpFld);
        inpFld.select();
        document.execCommand("copy");
        inpFld.remove(inpFld);

        Alert.error("Print screen is disabled.", {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    }
});

const Login = () => {
    const contextData = useContext(AuthDataContext);
    // eslint-disable-next-line
    const [License, setLicense] = useState(false);
    const [userData, setUserData] = useState(User);
    const [userdetail, setuserDetails] = useState(UserDetails);
    const [rolesData, setrolesData] = useState({});
    const [displaySignUpModel, setdisplaySignUpModel] = useState("none");

    useEffect(() => {
        FetchRoles();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchRoles = () => {
        Axiosfetch(baseURL + "GetActiveRoles", "GET", null, RoleSuccess, Failure);
    };

    const RoleSuccess = (data) => {
        if (data.length > 0) {
            var merchantRole = data.filter(u => u.Name.toUpperCase() === "USER");
            if (merchantRole.length > 0) {
                setrolesData(merchantRole[0]);
            }
        }
    };

    const onChange = (e) => {
        setuserDetails({ ...userdetail, [e.target.name]: e.target.value })
    };

    const onUserLogin = () => {
        var postData = {
            Loginfield: userdetail.UserName, Password: userdetail.Password
        };

        contextData.login(postData);
    };

    const keyPressed = (event) => {
        if (event.key === "Enter") {
            onUserLogin();
        }
    };

    const ShowSignupUser = () => {
        setdisplaySignUpModel("block");
    };

    const HideSignupUser = () => {
        setdisplaySignUpModel("none");
    };

    const onTextChange = (e) => {
        let value = e.target.value;
        setUserData({ ...userData, [e.target.name]: value });
    };

    const SaveSignupUser = () => {
        UserSchema.validate(userData).then(valid => {
            if (!IsUndefinedNullOrEmpty(rolesData._id)) {
                userData.RoleID = rolesData._id;
                userData.OrganizationID = null;
                userData.UserType = 0;
                Axiosfetch(baseURL + "CreateNormalUser", "POST", userData, UserDetailsSuccess, Failure);
            }
            else {
                Alert.error("Error While creating Account. Refresh the page and try again.", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }).catch(err => {
            Alert.error(err.message, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        });
    };

    const UserDetailsSuccess = (data) => {
        if (data.success) {
            HideSignupUser();
        }

        CallBackAlert(data);
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        !contextData.userData.Authenticate ? (<div className="container-fluid">
            <div className="row">
                <div style={{ padding: "0" }} className="col-md-9 imageIconMainStyle">
                    <img className="HeaderStyle mobileimageresponse" alt="PickNTrack" src={InvoiceIcon}></img>
                    <div className="mobileSectionStyle">
                        <div className="moveImage InfoImageStyle">
                            <img className="image" alt="PickNTrack" src={move}></img>
                            <h5 className="loginPStyle">Move</h5>
                            <h4 className="moveText">Movement of Goods made easy</h4>
                        </div>
                        <div className="InfoImageStyle packImage"><img className="image" alt="PickNTrack" src={pack}></img>
                            <h5 className="loginPStyle">Pack</h5>
                            <h4 className="packText">Packing of Goods with care</h4>
                        </div>
                        <div className="InfoImageStyle trackImage"><img className="image" alt="PickNTrack" src={track}></img>
                            <h5 className="loginPStyle">Track</h5>
                            <h4 className="trackText">Track your Shipment with Ease</h4>
                        </div>
                    </div>
                    <div className="mobileSectionStyle">
                        <div className="InfoImageStyle technologyImage">
                            <img className="image" alt="PickNTrack" src={technology}></img>
                            <h5 className="loginPStyle">Insight</h5>
                            <h4 className="technologyText">Business Partners Insight</h4>
                        </div>
                        <div className="InfoImageStyle storeImage"><img className="image" alt="PickNTrack" src={store}></img>
                            <h5 className="loginPStyle">Store</h5>
                            <h4 className="storeText">Storage of Goods in Inventory</h4>
                        </div>
                        <div className="InfoImageStyle networkImage"><img className="image" alt="PickNTrack" src={network}></img>
                            <h5 className="loginPStyle">Network</h5>
                            <h4 className="networkText">Network of Business Partners</h4>
                        </div>
                    </div>
                </div>
                <div className="col-md-3" style={{ padding: "0" }}>
                    <div className="loginTopIconStyle">
                        <img className="logo" width="auto" height="80" alt="Welcome Icon" src={WelcomeIcon}></img>
                        {contextData.userData.AuthMessage && <div style={{ padding: "20px" }}>
                            <div className="alert alert-danger" role="alert">
                                {contextData.userData.AuthMessage}
                            </div>
                        </div>
                        }
                    </div>
                    <div className="LoginRightStyle">
                        <div className="text-field" style={{ margin: "auto", marginBottom: "20px", width: "70%" }}>
                            <input autoFocus placeholder="" name="UserName" value={userdetail.UserName}
                                onChange={onChange}
                                type="text"></input>
                            <span>User Name</span>
                        </div>
                        <div className="text-field" style={{ margin: "auto", width: "70%" }}>
                            <input placeholder="" name="Password" value={userdetail.Password}
                                onChange={onChange}
                                type="password" onKeyPress={(e) => keyPressed(e)}></input>
                            <span>Password</span>
                        </div>
                        <div className="loginbtnStyle">
                            <button onClick={onUserLogin} className="btn btn-primary">
                                <span style={{ padding: "0 20px" }}>Login</span>
                            </button>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <span className="createAccountStyle" onClick={ShowSignupUser}>
                                Create your Account
                                <span style={{ paddingLeft: "10px" }}>
                                    <FontAwesomeIcon icon={faLongArrowAltRight} />
                                </span>
                            </span>
                        </div>
                    </div>
                    <div>
                        <footer className={`footer`} style={{ backgroundColor: "#E2FBFF" }}>
                            <div style={{ margin: "auto", padding: "4px 0  0 4px" }} className="footerContainer">
                                <p>© Movers Federation of India {process.env.REACT_APP_DEPLOY_YEAR} - {process.env.REACT_APP_VERSION}</p>
                            </div>
                        </footer>
                    </div>
                </div>

            </div>
            {/* <div id="myModalSignUp" className="modal" style={{ display: displaySignUpModel }}>
                <div className="modal-content">
                    <div className="modal-header header-style align-center">
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Create Account</span>
                        <span className="close" onClick={HideSignupUser}>&times;</span>
                    </div>
                    <div className="row" style={{ margin: "auto", marginTop: "10px", marginBottom: "10px" }}>
                        <h4>Pick N Track Launching Soon !!</h4>
                    </div>
                    <div className="row" style={{ margin: "auto", marginBottom: "10px" }}>
                        <h5>Join the Relocation Movement !!</h5>
                    </div>
                </div>
            </div> */}
            <div id="myModalSignUp" className="modal" style={{ display: displaySignUpModel }}>
                <div className="modal-content">
                    <div className="modal-header header-style align-center">
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Create Account</span>
                        <span className="close" onClick={HideSignupUser}>&times;</span>
                    </div>
                    <div className="row" style={{ marginTop: "10px", marginBottom: "10px" }}>
                        <div className="col-md-12 col-sm-12">
                            <table className="table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="text-field">
                                                <input autoFocus placeholder="" name="UserName" value={userData.UserName}
                                                    onChange={(e) => onTextChange(e)}
                                                    type="text"></input>
                                                <span>UserName *</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-field">
                                                <input autoFocus placeholder="" name="EmailID" value={userData.EmailID}
                                                    onChange={(e) => onTextChange(e)}
                                                    type="text"></input>
                                                <span>EmailID *</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="text-field">
                                                <input autoFocus placeholder="" name="FirstName" value={userData.FirstName}
                                                    onChange={(e) => onTextChange(e)}
                                                    type="text"></input>
                                                <span>FirstName *</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-field">
                                                <input autoFocus placeholder="" name="LastName" value={userData.LastName}
                                                    onChange={(e) => onTextChange(e)}
                                                    type="text"></input>
                                                <span>LastName *</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <div className="text-field">
                                                <input autoFocus placeholder="" name="PhoneNumber" value={userData.PhoneNumber}
                                                    onChange={(e) => onTextChange(e)}
                                                    type="text"></input>
                                                <span>PhoneNumber *</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-field">
                                                <input autoFocus placeholder="" name="Password" value={userData.Password}
                                                    onChange={(e) => onTextChange(e)}
                                                    type="password"></input>
                                                <span>Password *</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2" style={{ textAlign: "right" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <button type="button" style={{ fontSize: "1.4rem" }} className="btn btn-Save" onClick={SaveSignupUser}>Save</button>
                                                    <button type="button" className="btn btn-default" onClick={HideSignupUser}>Close</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>) : (<Redirect to="/Welcome"></Redirect>)
    )
}

export default Login
